import { isAnyOf } from '@reduxjs/toolkit';
import { startAppListening } from 'src/store/middleware/listenerMiddleware';
import { initThresholdSlice } from 'src/store/shared/threshold/factory';
import type { JsonFailure } from '@skynet/data-ws-core';
import { registerErrorMessage } from '@skynet/data-ws-core';
import { toThresholdUpdateData } from 'src/store/utils/thresholds';
import { isRecord } from 'src/utils/type-guards';

export enum ProjectAccountThresholdCommands {
  AccountThresholds = 'AccountThresholds',
  UpsertAccountThreshold = 'UpsertAccountThreshold',
  DeleteAccountThreshold = 'DeleteAccountThreshold',
}

registerErrorMessage(ProjectAccountThresholdCommands.DeleteAccountThreshold, {
  title: 'Delete Account Threshold Error',
  getDescription: (json: JsonFailure) => `${json.message}`,
});

registerErrorMessage(ProjectAccountThresholdCommands.UpsertAccountThreshold, {
  title: 'Add Account Threshold Error',
  getDescription: (json: JsonFailure) => `${json.message}`,
});

const projectAccountsThresholdSlice = initThresholdSlice({
  prefix: 'retainers',
  sliceName: 'threshold',
  commands: ProjectAccountThresholdCommands,
});

startAppListening({
  matcher: isAnyOf(
    projectAccountsThresholdSlice.actions.setAccountThreshold,
    projectAccountsThresholdSlice.actions.deleteAccountThreshold,
  ),
  effect: (action, api) => {
    if ('payload' in action && isRecord(action.payload)) {
      api.dispatch(
        projectAccountsThresholdSlice.actions.setThresholdUpdateData(
          toThresholdUpdateData(action.payload),
        ),
      );
    }
  },
});

export const retainerAccountsThresholdActions = projectAccountsThresholdSlice.actions;
export default projectAccountsThresholdSlice.reducer;
